import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** ADD DEALER DETAILS START *********************** */
export const dealerDetailsAdd = (addData: JSON) => {
	const data = {
		AddDealerToken: addData,
	};
	const url = `${API_URL}createDealer`;
	return makeApiCall(url, data);
};
/** ***************** ADD DEALER DETAILS END *********************** */

/** ***************** UPDATE DEALER DETAILS START *********************** */
export const dealerDetailsUpdate = (updateData: JSON) => {
	const data = {
		UpdateDealerToken: updateData,
	};
	const url = `${API_URL}updateDealer`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE DEALER DETAILS END *********************** */

/** ***************** GET DEALER DETAILS START *********************** */
export const dealerListGet = (listData: any) => {
	const data = {
		FetchDealerListToken: listData,
	};
	const url = `${API_URL}fetchDealerList`;
	return makeApiCall(url, data);
};
/** ***************** GET DEALER DETAILS END *********************** */

/** ***************** FETCH DEALER DETAILS START *********************** */
export const dealerDetailsFetch = (fetchData: any) => {
	const data = {
		GetParticularDealerToken: fetchData,
	};
	const url = `${API_URL}getParticullarDealer`;
	return makeApiCall(url, data);
};
/** ***************** FETCH DEALER DETAILS END *********************** */

/** ***************** DELETE DEALER DETAILS START *********************** */
export const dealerDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteDealerDetailToken: deleteData,
	};
	const url = `${API_URL}deleteDealer`;
	return makeApiCall(url, data);
};
/** ***************** DELETE DEALER DETAILS END *********************** */

/** ***************** DELETE DEALER STAFF DETAILS START *********************** */
export const dealerStaffDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteDealerStaffDetailToken: deleteData,
	};
	const url = `${API_URL}deleteDealerStaff`;
	return makeApiCall(url, data);
};
/** ***************** APPROVE DEALER START *********************** */
export const dealerApprove = (approveData: any) => {
	const data = {
		ApproveDealerToken: approveData,
	};
	const url = `${API_URL}approveDealer`;
	return makeApiCall(url, data);
};
/** ***************** APPROVE DEALER END *********************** */

/** ***************** DELETE DEALER STAFF DETAILS END *********************** */
